export const getToolbarHeaderStyles = () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '2px',
  },
  regularButtonIcon: {
    textAlign: 'center',
    color: 'inherit',
    lineHeight: '16px',
    paddingBottom: '6px',
  },
  compactButtonIcon: {
    textAlign: 'center',
    color: 'inherit',
    fontSize: '20px !important',
    lineHeight: '20px',
  },
  text: {
    textAlign: 'center',
    fontSize: '14px',
    lineHeight: '14px',
    minHeight: '16px',
    fontWeight: 'normal',
    color: 'inherit',
  },
  svgicon: {
    display: 'flex',
    justifyContent: 'center',
    margin: '3px 0px',
  },
});
